module.exports = __webpack_public_path__ + "img/18dd52930bba4b139945bae44539b273-640.2af47f59.jpg";